
import { defineComponent } from 'vue'

import AsModal from '@web/components/AsModal.vue'
import AsRenewModal from '@web/components/AsRenewModal.vue'

import { Stream } from '@web/store/types/modules/stream'

export default defineComponent({
  props: {
    stream: {
      type: Object as () => Stream,
      required: true
    }
  },
  emits: ['close'],
  components: {
    AsModal,
    AsRenewModal
  }
})
